// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"e0dd877b","153":"22e409cd","335":"aa43a29b","395":"aa43a29b","916":"31d6cfe0"}[chunkId] + ".chunk.css";
};